// extracted by mini-css-extract-plugin
export default {"page_container":"AppRedirectPage_page_container__c+CSG","loading_spinner":"AppRedirectPage_loading_spinner__r6Q3t","redirect_text":"AppRedirectPage_redirect_text__0oBwm"};